import CoveragePanel from "./CoveragePanel";

/** Auto-detected financial-model coverage. */
export default function FinancialCoveragePanel() {
  return (
    <CoveragePanel
      endpoint="/founder/readiness/financial-coverage"
      hasFlag="has_excel"
      title="Financial Model Coverage"
      testId="financial-coverage-card"
      emptyTitle="No financial model uploaded yet"
      emptyBody="Upload your Excel model and we'll automatically detect your P&L, Balance Sheet, Cash Flow, Assumptions and key metrics — so we can score every section."
      uploadCtaLabel="Upload financial model"
      serviceFocus="financial_model"
      serviceCtaLabel="Have Clinq build my financial model"
    />
  );
}
